import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../context/AppContext";
import "bootstrap/dist/css/bootstrap.min.css";
//Datatable Modules
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import ic_sub from "../assets/images/ic_sub.svg";
import Modal from "react-bootstrap/Modal";
import { Row } from "react-bootstrap";

import {
  DeleteCallWithErrorResponse,
  getWithAuthCallWithErrorResponse,
  postWithAuthCall,
  putWithAuthCall,
  simpleGetCallWithErrorResponse,
} from "../api/ApiServices";
import ApiConfig from "../api/ApiConfig";
import { ToastMsg } from "./ToastMsg";
import redDelete from "../assets/images/redDelete.svg";
import IconEdit from "../assets/images/Article_Edit.svg";

const currencyList = [
  {
    symbol: "$",
    name: "United States Dollar",
    code: "USD",
  },
  {
    symbol: "€",
    name: "Euro",
    code: "EUR",
  },
  {
    symbol: "¥",
    name: "Japanese Yen",
    code: "JPY",
  },
  {
    symbol: "£",
    name: "British Pound Sterling",
    code: "GBP",
  },
  {
    symbol: "₽",
    name: "Russian Ruble",
    code: "RUB",
  },
  {
    symbol: "₹",
    name: "Indian Rupee",
    code: "INR",
  },
  {
    symbol: "C$",
    name: "Canadian Dollar",
    code: "CAD",
  },
  {
    symbol: "A$",
    name: "Australian Dollar",
    code: "AUD",
  },
];

// RevenueCat reports prices with an ISO 4217 code; the plan schema stores
// { name, symbol }. Fall back to showing the raw code for currencies we don't
// have a symbol for.
const resolveCurrency = (code) =>
  currencyList.find((c) => c.code === code) || { name: code || "", symbol: code || "" };

// v2 Product carries indicative_price: { currency, country, amount_micros }.
const priceFromProduct = (product) => {
  const indicative = product && product.indicative_price;
  if (!indicative || typeof indicative.amount_micros !== "number") {
    return { price: 0, currency: resolveCurrency("USD") };
  }
  return {
    price: indicative.amount_micros / 1000000,
    currency: resolveCurrency(indicative.currency),
  };
};
const Subscription = () => {
  const { sidebar } = useContext(AppContext);

  const [deleteModal, setDelete] = useState(false);
  const [editSubPackage, setEditSubPackage] = useState(false);
  const [deleteSubPackage, setDeleteSubPackage] = useState(null);
  const handleDeleteClose = () => setDelete(false);

  const [packageDetails, setPackageDetails] = useState({
    title: "",
    gradientStart: "",
    gradientStop: "",
    description: "",
    features: [],
    packages: [],
  });
  const [subPackages, setSubPackages] = useState([]);
  const [viewModal, setView] = useState({
    show: false,
    update: false,
    pack: null,
  });
  const handleViewClose = () => setView(false);
  const handleViewUpdateModal = (pack) => {
    setView({ show: true, update: true, pack: pack });
    setPackageDetails({
      title: pack.title,
      description: pack.description,
      features: pack.features,
      packages: pack.packages,
    });
    setSubPackages(pack.packages);
  };
  const handleViewAddModal = () => setView({ show: true, update: false });

  const [packages, setPackages] = useState([]);

  const emptySubPackage = () => ({
    name: "",
    product_id: "",
    entitlement_id: "",
    offering_id: "",
    duration: "",
    price: 0,
    currency: currencyList.find((e) => e.symbol === "€"),
  });

  const [currentSubPackage, setCurrentSubpackage] = useState(emptySubPackage());

  // RevenueCat project config, used to drive the dropdowns below. If it can't
  // be loaded (key missing, RevenueCat down) we fall back to free-text entry so
  // this page never hard-breaks.
  const [rcProducts, setRcProducts] = useState([]);
  const [rcEntitlements, setRcEntitlements] = useState([]);
  const [rcOfferings, setRcOfferings] = useState([]);
  const [rcAvailable, setRcAvailable] = useState(false);
  const [rcError, setRcError] = useState("");

  // Sync report: product_id -> verdict, plus RC products no plan references.
  const [syncVerdicts, setSyncVerdicts] = useState({});
  const [orphanProducts, setOrphanProducts] = useState([]);
  // The orphan-products warning is collapsed by default (shown via a small
  // badge next to the "last checked" line); this toggles the full alert open.
  const [showOrphans, setShowOrphans] = useState(false);
  const [syncCheckedAt, setSyncCheckedAt] = useState(null);
  const [syncLoading, setSyncLoading] = useState(false);

  const loadSyncStatus = () => {
    setSyncLoading(true);
    getWithAuthCallWithErrorResponse(ApiConfig.RC_SYNC_STATUS)
      .then((res) => {
        const data = res?.json?.data;
        if (!data) return;
        const map = {};
        (data.plans || []).forEach((plan) =>
          (plan.packages || []).forEach((pkg) => {
            if (pkg.product_id) map[pkg.product_id] = pkg.verdict;
          })
        );
        setSyncVerdicts(map);
        setOrphanProducts(data.orphanProducts || []);
        setSyncCheckedAt(data.checkedAt || null);
      })
      .catch(() => {})
      .finally(() => setSyncLoading(false));
  };

  // Badge for a package's sync verdict; unknown until the report loads.
  const syncBadge = (productId) => {
    const v = syncVerdicts[productId];
    if (!v) return null;
    if (v === "synced")
      return <span className="badge bg-success ms-2">Synced</span>;
    if (v === "missing_product")
      return <span className="badge bg-danger ms-2">Not in RevenueCat</span>;
    return (
      <span className="badge bg-warning text-dark ms-2">
        {v === "missing_entitlement"
          ? "Entitlement missing"
          : v === "missing_offering"
          ? "Offering missing"
          : "No product ID"}
      </span>
    );
  };

  const getRevenueCatConfig = () => {
    Promise.all([
      getWithAuthCallWithErrorResponse(ApiConfig.RC_PRODUCTS),
      getWithAuthCallWithErrorResponse(ApiConfig.RC_ENTITLEMENTS),
      getWithAuthCallWithErrorResponse(ApiConfig.RC_OFFERINGS),
    ])
      .then(([products, entitlements, offerings]) => {
        if (products.error || !Array.isArray(products.json?.data)) {
          setRcAvailable(false);
          setRcError(
            products.json?.message ||
              "Could not load RevenueCat products - falling back to manual entry."
          );
          return;
        }
        setRcProducts(products.json.data);
        setRcEntitlements(
          !entitlements.error && Array.isArray(entitlements.json?.data)
            ? entitlements.json.data
            : []
        );
        setRcOfferings(
          !offerings.error && Array.isArray(offerings.json?.data)
            ? offerings.json.data
            : []
        );
        setRcAvailable(true);
        setRcError("");
      })
      .catch(() => {
        setRcAvailable(false);
        setRcError("Could not reach RevenueCat - falling back to manual entry.");
      });
  };

  // Selecting a product also pins the price/currency from RevenueCat, so the
  // admin can no longer type a price that drifts from what the store charges.
  const handleSelectProduct = (storeIdentifier) => {
    const product = rcProducts.find(
      (p) => p.store_identifier === storeIdentifier
    );
    const { price, currency } = priceFromProduct(product);
    setCurrentSubpackage({
      ...currentSubPackage,
      product_id: storeIdentifier,
      price,
      currency,
    });
  };

  const handleAddSubPackage = (event) => {
    event.preventDefault();
    // Price is no longer required here: with RevenueCat it is derived from the
    // selected product and may legitimately be 0 until the store reports one.
    if (
      currentSubPackage.name &&
      currentSubPackage.product_id &&
      currentSubPackage.duration
    ) {
      setSubPackages([...subPackages, currentSubPackage]);
      setCurrentSubpackage(emptySubPackage());
    }
  };

  const handleRemoveSubPackage = () => {
    console.log({ deleteSubPackage });
    const updatedSubPackages = subPackages.filter((pack) => {
      if (pack._id) {
        if (pack._id !== deleteSubPackage._id) {
          return true;
        }
      } else {
        if (pack.name !== deleteSubPackage._id) {
          return true;
        }
      }
    });
    setSubPackages(updatedSubPackages);
    setDelete(false);
  };

  const addPackage = (event) => {
    event.preventDefault();
    const _features = packageDetails.features
      .toString()
      .split(",")
      .map((e) => e.trim());
    const pkg = {
      ...packageDetails,
      features: _features,
      packages: subPackages,
    };
    setPackageDetails(packageDetails);

    console.log(pkg);
    if (viewModal.update && viewModal.pack._id) {
      updateMembershipPlan(viewModal.pack._id, pkg);
    } else if (viewModal.update == false) {
      addMembershipPlan(pkg);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPackageDetails((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const updateMembershipPlan = (id, body) => {
    putWithAuthCall(
      `${ApiConfig.ADD_SUBSCRIPTION_PLAN}/${id}`,
      JSON.stringify(body)
    )
      .then((response) => {
        // The server rejects product/entitlement/offering IDs RevenueCat
        // doesn't know — keep the modal open and show exactly what's wrong.
        if (response && response.error) {
          ToastMsg("error", response.message || "Save failed");
          return;
        }
        if (response && response.warnings && response.warnings.length) {
          ToastMsg("warning", response.warnings[0]);
        }
        handleViewClose();
        getAllMembershipPlans();
        loadSyncStatus();
      })
      .catch((error) => {
        console.log(error);
        ToastMsg("error", "Save failed");
      });
  };

  const addMembershipPlan = (body) => {
    postWithAuthCall(`${ApiConfig.ADD_SUBSCRIPTION_PLAN}`, JSON.stringify(body))
      .then((response) => {
        if (response && response.error) {
          ToastMsg("error", response.message || "Save failed");
          return;
        }
        if (response && response.warnings && response.warnings.length) {
          ToastMsg("warning", response.warnings[0]);
        }
        handleViewClose();
        getAllMembershipPlans();
        loadSyncStatus();
      })
      .catch((error) => {
        console.log(error);
        ToastMsg("error", "Save failed");
      });
  };

  const getAllMembershipPlans = () => {
    simpleGetCallWithErrorResponse(`${ApiConfig.GET_ALL_SUBSCRIPTION_PLANS}`)
      .then((response) => {
        if (response.json.data) {
          setPackages(response.json.data["plans"]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteMembershipPlan = (id) => {
    DeleteCallWithErrorResponse(`${ApiConfig.ADD_SUBSCRIPTION_PLAN}/${id}`)
      .then((response) => {
        if (response) {
          handleViewClose();
          getAllMembershipPlans();
        }
      })
      .catch((error) => {
        console.log(error);
        handleViewClose();
      });
  };

  const deletePackage = (event, id) => {
    event.preventDefault();
    deleteMembershipPlan(id);
  };

  const handleEditSubPackage = () => {
    console.log({ currentSubPackage, subPackages });
    const updatedSubPackages = subPackages.map((pack) => {
      if (pack._id) {
        if (pack._id === currentSubPackage._id) {
          return currentSubPackage;
        }
        return pack;
      } else {
        if (pack.name === currentSubPackage._id) {
          return currentSubPackage;
        }
        return pack;
      }
    });

    setSubPackages(updatedSubPackages);
  };

  useEffect(() => {
    getAllMembershipPlans();
    loadSyncStatus();
    getRevenueCatConfig();
  }, []);

  console.log("render", { subPackages });
  return (
    <main
      id="cx-main"
      className={sidebar ? "admin-main" : "cx-active admin-main"}
    >
      <div className="heading-btn-main">
        <div className="heading-common">
          <label htmlFor="">Subscription</label>
        </div>
        <div className="add-btn">
          <button
            className="btn btn-outline-secondary me-2"
            onClick={loadSyncStatus}
            disabled={syncLoading}
            title="Re-check every package against RevenueCat"
          >
            {syncLoading ? "Checking…" : "Validate sync"}
          </button>
          <button onClick={handleViewAddModal}>
            Add Subscription
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
            >
              <path fill="white" d="M11 19v-6H5v-2h6V5h2v6h6v2h-6v6Z" />
            </svg>
          </button>
        </div>
      </div>

      {/* Sync report banners. Orphans = products RevenueCat can sell but no
          plan shows in the app — usually a plan that was deleted or never made. */}
      {syncCheckedAt && (
        <p className="text-muted small mb-2">
          Sync with RevenueCat last checked:{" "}
          {new Date(syncCheckedAt).toLocaleString()}
          {orphanProducts.length > 0 && (
            <span
              className="badge bg-warning text-dark ms-2"
              role="button"
              style={{ cursor: "pointer" }}
              title={`${orphanProducts.length} RevenueCat product${
                orphanProducts.length === 1 ? "" : "s"
              } not shown in the app — click for details`}
              onClick={() => setShowOrphans((v) => !v)}
            >
              ⚠ {orphanProducts.length} unused {showOrphans ? "▲" : "▼"}
            </span>
          )}
        </p>
      )}
      {orphanProducts.length > 0 && showOrphans && (
        <div className="alert alert-warning py-2" style={{ fontSize: "13px" }}>
          <strong>
            {orphanProducts.length} RevenueCat product
            {orphanProducts.length === 1 ? "" : "s"} not shown in the app:
          </strong>{" "}
          {orphanProducts.join(", ")} — no subscription plan references them, so
          members can never see or buy them.
        </div>
      )}

      <Modal
        show={deleteModal}
        onHide={handleDeleteClose}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Message</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-msg text-center" style={{ fontSize: "12px" }}>
            <label htmlFor="">
              Are you sure you want to delete this sub-package?
            </label>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <div className="buttons-modal    ">
            <button
              onClick={handleRemoveSubPackage}
              className="me-2 bg-danger"
              type="submit"
            >
              Yes
            </button>
            <Link to="#" className="" onClick={handleDeleteClose}>
              No
            </Link>
          </div>
        </Modal.Footer>
      </Modal>
      {/* ======================= END DELETE ========================== */}

      {/* ======================= VIEW ========================== */}
      <Modal
        show={viewModal.show}
        onHide={handleViewClose}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {viewModal.update ? "Update" : "Add"} Membership Plan
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="row">
              <div className="col-md-12 mb-3">
                <Form.Label>Package Name</Form.Label>
                <Form.Control
                  type="text"
                  name="title"
                  value={packageDetails.title}
                  placeholder="Package Name"
                  onChange={handleChange}
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Name
                </Form.Control.Feedback>
              </div>

              <div className="col-md-12 mb-3">
                <Form.Label>Package Theme</Form.Label>

                <Form.Control
                  type="text"
                  name="gradientStart"
                  placeholder="Color Start"
                  className=""
                  onChange={handleChange}
                />
                <Form.Control
                  type="text"
                  name="gradientStop"
                  placeholder="Color Stop"
                  className="mb-3"
                  onChange={handleChange}
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Name
                </Form.Control.Feedback>
              </div>

              <div className="col-md-12 mb-3">
                <Form.Label>Package Description</Form.Label>

                <Form.Control
                  as="textarea"
                  rows={2} // You can adjust the number of rows as needed
                  name="description"
                  placeholder="Package Description"
                  value={packageDetails.description}
                  onChange={handleChange}
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Description
                </Form.Control.Feedback>
              </div>

              <div className="col-md-12 mb-3">
                <Form.Label>Package Features</Form.Label>

                <Form.Control
                  as="textarea"
                  rows={4} // You can adjust the number of rows as needed
                  name="features"
                  placeholder="feature1, feature2 ..."
                  value={packageDetails.features}
                  onChange={handleChange}
                />
                <Form.Control.Feedback type="invalid">
                  Please Enter Features
                </Form.Control.Feedback>
              </div>

              <div className="col-md-12 mb-3">
                <Form.Label>Sub Packages</Form.Label>
                {!rcAvailable && rcError ? (
                  <div className="alert alert-warning py-2" style={{ fontSize: "12px" }}>
                    {rcError}
                  </div>
                ) : (
                  <></>
                )}
                {subPackages.map((subPackage, index) => (
                  <Row key={index}>
                    <div className="d-flex justify-content-start align-items-center">
                      <b>
                        {subPackage.name}({subPackage.duration})
                      </b>{" "}
                      - {subPackage.currency ? subPackage.currency.symbol : "$"}
                      {subPackage.price}
                      <Link to="#" className="icon edit text-end ms-2">
                        <img
                          src={redDelete}
                          className="text-end"
                          alt=""
                          onClick={() => {
                            setDelete(true);
                            const subPackData = {
                              ...subPackage,
                              _id: subPackage._id ?? subPackage.name,
                            };
                            setDeleteSubPackage(subPackData);
                          }}
                        />
                      </Link>
                      <Link to="#" className="icon edit text-end ms-2">
                        <img
                          src={IconEdit}
                          className="text-end"
                          alt=""
                          onClick={() => {
                            const subPackData = {
                              ...subPackage,
                              _id: subPackage._id ?? subPackage.name,
                            };
                            setCurrentSubpackage(subPackData);
                            setEditSubPackage(true);
                          }}
                        />
                      </Link>
                    </div>
                    <div className="mb-3 d-flex justify-content-start align-items-center">
                      {subPackage.product_id}
                      {syncBadge(subPackage.product_id)}
                      {subPackage.entitlement_id ? (
                        <span className="badge bg-secondary ms-2">
                          {subPackage.entitlement_id}
                        </span>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="mb-3"></div>
                  </Row>
                ))}
                <div className="col ">
                  <Form.Control
                    type="text"
                    placeholder="Package Name"
                    className="mb-3"
                    value={currentSubPackage.name}
                    onChange={(e) =>
                      setCurrentSubpackage({
                        ...currentSubPackage,
                        name: e.target.value,
                      })
                    }
                  />
                  {rcAvailable ? (
                    <Form.Select
                      aria-label="Select RevenueCat product"
                      className="mb-3"
                      value={currentSubPackage.product_id || ""}
                      onChange={(e) => handleSelectProduct(e.target.value)}
                    >
                      <option value="">Select RevenueCat product...</option>
                      {rcProducts.map((product) => (
                        <option key={product.id} value={product.store_identifier}>
                          {(product.display_name || product.store_identifier) +
                            " - " +
                            product.store_identifier}
                        </option>
                      ))}
                    </Form.Select>
                  ) : (
                    <Form.Control
                      type="text"
                      placeholder="Product ID"
                      className="mb-3"
                      value={currentSubPackage.product_id}
                      onChange={(e) =>
                        setCurrentSubpackage({
                          ...currentSubPackage,
                          product_id: e.target.value,
                        })
                      }
                    />
                  )}

                  {rcAvailable ? (
                    <Form.Select
                      aria-label="Select entitlement"
                      className="mb-3"
                      value={currentSubPackage.entitlement_id || ""}
                      onChange={(e) =>
                        setCurrentSubpackage({
                          ...currentSubPackage,
                          entitlement_id: e.target.value,
                        })
                      }
                    >
                      <option value="">Select entitlement...</option>
                      {rcEntitlements.map((entitlement) => (
                        <option
                          key={entitlement.id}
                          value={entitlement.lookup_key}
                        >
                          {(entitlement.display_name || entitlement.lookup_key) +
                            " - " +
                            entitlement.lookup_key}
                        </option>
                      ))}
                    </Form.Select>
                  ) : (
                    <Form.Control
                      type="text"
                      placeholder="Entitlement ID (e.g. premium)"
                      className="mb-3"
                      value={currentSubPackage.entitlement_id || ""}
                      onChange={(e) =>
                        setCurrentSubpackage({
                          ...currentSubPackage,
                          entitlement_id: e.target.value,
                        })
                      }
                    />
                  )}

                  {rcAvailable ? (
                    <Form.Select
                      aria-label="Select offering"
                      className="mb-3"
                      value={currentSubPackage.offering_id || ""}
                      onChange={(e) =>
                        setCurrentSubpackage({
                          ...currentSubPackage,
                          offering_id: e.target.value,
                        })
                      }
                    >
                      <option value="">Select offering (optional)...</option>
                      {rcOfferings.map((offering) => (
                        <option
                          key={offering.id}
                          value={offering.lookup_key || offering.id}
                        >
                          {(offering.display_name ||
                            offering.lookup_key ||
                            offering.id) +
                            " - " +
                            (offering.lookup_key || offering.id)}
                        </option>
                      ))}
                    </Form.Select>
                  ) : (
                    <Form.Control
                      type="text"
                      placeholder="Offering ID (optional)"
                      className="mb-3"
                      value={currentSubPackage.offering_id || ""}
                      onChange={(e) =>
                        setCurrentSubpackage({
                          ...currentSubPackage,
                          offering_id: e.target.value,
                        })
                      }
                    />
                  )}

                  <Form.Control
                    type="text"
                    placeholder="Package Duration"
                    className="mb-3"
                    value={currentSubPackage.duration}
                    onChange={(e) =>
                      setCurrentSubpackage({
                        ...currentSubPackage,
                        duration: e.target.value,
                      })
                    }
                  />
                  <div></div>

                  {rcAvailable ? (
                    <Form.Control
                      type="text"
                      readOnly
                      disabled
                      className="mb-3"
                      title="Price comes from RevenueCat / the store and cannot be edited here"
                      value={
                        currentSubPackage.product_id
                          ? `${currentSubPackage.currency?.symbol ?? ""}${
                              currentSubPackage.price
                            } ${currentSubPackage.currency?.name ?? ""} (from RevenueCat)`
                          : "Price is taken from the selected RevenueCat product"
                      }
                    />
                  ) : (
                    <>
                      <Form.Select
                        aria-label="Select Currency"
                        className="mb-3"
                        value={currentSubPackage.currency?.name}
                        onChange={(event) =>
                          setCurrentSubpackage({
                            ...currentSubPackage,
                            currency: currencyList.find(
                              (e) => e.name === event.target.value
                            ),
                          })
                        }
                      >
                        {currencyList.map((currency) => (
                          <option value={currency.name} key={currency.name}>
                            {currency.name + " - " + currency.symbol}
                          </option>
                        ))}
                      </Form.Select>

                      <Form.Control
                        type="text"
                        placeholder="Package Price"
                        value={currentSubPackage.price}
                        className="mb-3"
                        onChange={(e) =>
                          setCurrentSubpackage({
                            ...currentSubPackage,
                            price: e.target.value,
                          })
                        }
                      />
                    </>
                  )}
                </div>
                <div className="buttons-modal text-start mb-3">
                  <button
                    className="bg-secondary"
                    type="button"
                    onClick={
                      editSubPackage
                        ? handleEditSubPackage
                        : handleAddSubPackage
                    }
                  >
                    {editSubPackage ? "Update" : "Add"}
                  </button>
                  {viewModal.update && editSubPackage ? (
                    <button
                      className="bg-secondary ms-3"
                      type="button"
                      onClick={() => {
                        setCurrentSubpackage(emptySubPackage());
                        setEditSubPackage(false);
                      }}
                    >
                      Cancel
                    </button>
                  ) : (
                    <></>
                  )}
                </div>

                <Form.Control.Feedback type="invalid">
                  Please Enter Name
                </Form.Control.Feedback>
              </div>
            </div>
            <div
              className="buttons-modal border-top pt-3 text-end "
              style={{ display: "flex", gap: "10px", justifyContent: "end" }}
            >
              {viewModal.update ? (
                <button
                  className="bg-danger"
                  onClick={(event) => deletePackage(event, viewModal.pack._id)}
                >
                  Delete
                </button>
              ) : (
                <></>
              )}

              <button className="bg-danger" onClick={addPackage}>
                Submit
              </button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
      {/* ======================= END VIEW ========================== */}

      <div className="documents-wrapper">
        <div className="row g-3">
          {packages.map((pack) => (
            <div className="col-md-4" key={pack.title}>
              <div className="document-cards">
                <div className="paln-card b">
                  <div>
                    <img src={ic_sub} alt="" />
                  </div>
                  <div className="name-c">{pack.title}</div>
                </div>
                <div className="buttons-wrapper mt-3">
                  <button
                    style={{ backgroundColor: "#055D9D" }}
                    className="btn  text-white w-100"
                    onClick={() => handleViewUpdateModal(pack)}
                  >
                    Upgrade Plan
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default Subscription;
